
import React , {Component} from 'react';
import axios from 'axios';
// import  url from '../url';
// import './tablehover.css';
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'

const $ = require('jquery');
$.DataTable = require('datatables.net');

require( 'datatables.net-buttons/js/dataTables.buttons.min' );
const jzip = require( 'jzip');
require( 'datatables.net-buttons/js/buttons.html5.min' );

window.JSZip = jzip;

export default class BooksDatatable extends Component{

    constructor(props){
        super(props);
        this.reloadTableData = this.reloadTableData.bind(this);
        this.updateTable = this.updateTable.bind(this);
    }
    componentDidMount(){
        let colArr = this.props.columns;
        console.log(colArr)

        this.$el = $(this.el);
        this.$el.DataTable({
            data:[],
            "sPaginationType": "full_numbers",
            "aaSorting":[],
            columns:colArr,
            columnDefs: [
                {
                    targets: '_all',
                    className: 'dt-center'
                }
              ],
            paging:this.props.paging,
            dom: 'Blfrtip',
            buttons: [
                'csvHtml5'
            ]
            
        })
        if(this.props.tData.length > 0){
            var t = this.$el.DataTable();
            console.log('map and aff')
            this.props.tData.map(data => {
                t.row.add(data).draw();
            })
        }
        const ta = this.$el.dataTable()
        var that = this;
        
    }

    reloadTableData(data) {
        const table = this.$el.DataTable();
        console.log('reloadTableData')
        table.clear();
        table.rows.add(data);
        table.draw();
        if(this.props.getTableInstance){
            this.props.getTableInstance(table)
        }
    }

    updateTable(names) {
        console.log('inside updatetable')
        const table = this.$el.DataTable();
        let dataChanged = false;
        table.rows().every(function () {
            console.log(this.data())
            const oldNameData = this.data();
            
            const newNameData = names.find((nameData) => {
                return nameData.id === oldNameData.id;
            });
            if (oldNameData.status !== newNameData.status) {
                dataChanged = true;
                this.data(newNameData);
            }
            return true; 
        });
    
        if (dataChanged) {
            table.draw();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.tData.length !== this.props.tData.length) {
            // console.log('calling reloadtable ')
            this.reloadTableData(nextProps.tData);
        } 
        return false;
    }

    componentWillUnmount(){
        this.$el.find('table')
        .DataTable()
        .destroy(true);
        // DataTable().destroy(true);
    }

    render(){
        return <div>
            <table className="cell-border dataTable display" id = "tbl" ref = {el => this.el = el}></table>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/Components/SwapSuggestion/booksDatatable.js